import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverSettlementProfileList extends Layout {
    layoutheaderDriverSettlementList: LayoutHeader;
    sourceDriverSettlementProfile: DataSource;
    tableDriverSettlementProfiles: Table;
}
